import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

function AboutPage({ tenantName, tenant }) {
    const buildTime = process.env.REACT_APP_BUILD_TIME;

    const formatBuildTime = (isoString) => {
        if (!isoString) return null;
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return null;
        return date.toLocaleString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="about-page-container">
            <header className="gallery-header">
                <h1>{tenant?.public_title || `${tenant?.name} Gallery`}</h1>
                <p className="gallery-subtitle">
                    <Link to={`/${tenantName}`} className="albums-link">Albums</Link>
                </p>
            </header>

            <div className="about-content">
                <div className="about-text">
                    {tenant?.about_text}
                </div>
            </div>

            <footer className="about-footer">
                <p className="build-info">
                    Last updated: {formatBuildTime(buildTime) || buildTime || 'Build time not set'}
                </p>
            </footer>
        </div>
    );
}

export default AboutPage;
